export default __webpack_public_path__ + "static/logo-655b97b66f3306a68f832b45b5acb61e.png";